import styled, {css} from 'styled-components'

import theme, {media} from '@/src/config/theme'

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`

export const Form = styled.div`
  padding: ${theme.token.layout.pagePadding}px;
  max-width: 650px;
  width: 100%;
  border: solid 1px ${theme.colors.gray6};
  box-shadow: 0 0 16px ${theme.colors.boxShadow};
  
  border-radius: 5px;

  @media ${media.md} {
    padding: 27px;
  }
`

export const Head = styled.div`
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 27px;
  border-bottom: solid 1px ${theme.colors.gray6};
`

export const Title = styled.div`
  font-weight: 450;
  font-size: 1.25rem;
`

export const Container = styled.div<{$haveTitle?: boolean}>`
  ${props =>
    props.$haveTitle &&
    css`
      padding-top: 27px;
    `}
`
